<p>tabular-pipeline-dates works!</p>
